import {
  FormControl,
  InputLabel,
  MenuItem,
  makeStyles,
  Select,
} from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import useFetch from "../../../../../hooks/useFetch";
import Arab from "../../../../../Image/Arab.png";
import Dubai from "../../../../../Image/dubai.png";
import footprint from "../../../../../Image/footprint.png";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 145,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const InProgress = () => {
  const { data } = useFetch("https://abc-backend.onrender.com/api/quotes");
  const [view, setView] = React.useState("");
  const classes = useStyles();
  const handleChange = (event) => {
    setView(event.target.value);
  };
  return (
    <div className="tabelMain">
      {data?.map((item, i) => (
        <>
          {item.InProgress && (
            <div className="card" style={{ marginBottom: "20px" }} key={i}>
              <div className="card-heading card-heading1 approvalTabel">
                <div>
                  <h5>ID</h5>
                </div>
                <div>
                  <h5 className="countryTitle">
                    {item?.data?.loadingUnDetailsValue[0]?.locationFrom}
                    {"  "}
                    {item?.data?.loadingUnDetailsValue[0]?.locationTo}
                  </h5>
                </div>
                <div className="selected">
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-simple-select-autowidth-label">
                      Submit Quote
                    </InputLabel>
                    <Select
                      value={view}
                      onChange={handleChange}
                      displayEmpty
                      defaultValue={"Approve"}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem
                        value={"Submit Quote"}
                        className="admin_view_quote"
                      >
                        <Link to={`/dashboard/quotes/${item._id}`}>
                          {" "}
                          View Quotes
                        </Link>
                      </MenuItem>
                      <MenuItem
                        value={"Submit Quote"}
                        className="admin_view_quote"
                      >
                        <Link to={`/dashboard/req-for-change`}>
                          Request for Change
                        </Link>
                      </MenuItem>
                      <MenuItem
                        value={"Submit Quote"}
                        className="admin_view_quote"
                      >
                        <Link to={`/dashboard/reject`}>Reject</Link>
                      </MenuItem>
                      <MenuItem
                        value={"Submit Quote"}
                        className="admin_view_quote"
                      >
                        <Link to={`/dashboard/approve`}>Approve</Link>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="card-heading">
                <div>
                  <h5>100001</h5>
                  <h5>13-Sep-2022 07:05</h5>
                  <h5>{item?.data?.quoteIntValue?.transportationType}</h5>
                </div>
                <div>
                  <h6>Services:</h6>
                  <h6>Product:</h6>
                  <h6>Loading Date:</h6>
                </div>
                <div>
                  <h5>Road Transportation</h5>
                  <h5>{item?.data?.quoteIntValue?.productType}</h5>
                  <h5>{item?.data?.quoteIntValue?.loadDate}</h5>
                </div>
                <div className="footprint_img">
                  <img src={footprint} alt="footprint" />
                  <span>100 g</span>
                </div>
              </div>
              {item?.data?.loadingUnDetailsValue.map((lcData, i) => (
                <div className="card-heading" key={i}>
                  <div>
                    <h5> {lcData?.locationFrom}</h5>
                    <h6 className="country"> {lcData?.locationFrom}</h6>
                    <img width="40" height="25" src={Dubai} alt="" />
                    <h5>Pickup</h5>
                  </div>
                  <div>
                    <h5>{lcData?.locationTo}</h5>
                    <h6 className="country">{lcData?.locationTo}</h6>
                    <img width="40" height="25" src={Arab} alt="" />
                    <h5>Destination</h5>
                  </div>
                </div>
              ))}
              <div className="user_dashboard_line"></div>
            </div>
          )}
        </>
      ))}
      {data?.length < 0 && <h2 style={{ height: "100vh" }}>No Quote Found</h2>}
    </div>
  );
};

export default InProgress;
